<section class="pt-16 px-container">
    <h1 class="text-5xl md:text-6xl">Condizioni generali di contratto</h1>
</section>

<section class="py-16 mb-8 px-container text-justify">
    <h5 class="my-5 font-bold text-xl">1. Oggetto del servizio</h5>
    <p>
        Il sistema di acquisto on-line offre all'utente un servizio di prevendita dei biglietti relativi agli eventi
        disponibili su www.teatrocolosseo.it
    </p>
    <h5 class="my-5 font-bold text-xl">2. Modalità di vendita dei biglietti</h5>
    <p>
        Il numero dei biglietti acquistabili per ogni operazione o persona potrà arrivare al numero massimo di 10. Gli
        eventi sono normalmente in vendita on-line fino al giorno e all'ora della loro effettuazione, salvo diverse
        disposizioni particolari che possono essere anche applicate senza preavviso alcuno. Generalmente non si possono
        acquistare on-line titoli d'accesso con riduzione, in quanto non è possibile provvedere all'opportuna verifica
        del diritto alla riduzione stessa. Nel caso venisse data questa possibilità, l'utente dovrà presentarsi al
        controllo biglietti con un titolo che consenta alla maschera di verificare il diritto alla riduzione.
    </p>
    <h5 class="my-5 font-bold text-xl">3. Pagamento dei biglietti</h5>
    <p>
        Il pagamento degli acquisti on-line viene effettuato tramite i maggiori circuiti di carta di credito (Visa e
        Mastercard), anche prepagate.<br />
        Il titolo di accesso inviato al termine della procedura di acquisto è valido come ricevuta fiscale dell'acquisto
        stesso. Al termine dell’acquisto l’utente riceverà una mail da parte del circuito Nexi con la conferma d’ordine
        e poi una mail con il/i Titolo/i di ingresso acquistato/ i, come allegato in formato PDF. <br />
        Per le caratteristiche particolari del settore, le norme vigenti nell'ambito della biglietteria di spettacolo o
        di eventi in genere, ogni transazione portata a termine dall'utente si intende implicitamente e definitivamente
        accettata dal medesimo.<br />
        Il collegamento allo sportello virtuale di pagamento avviene in modalità sicura con crittografia SSL (Secure
        Socket Layer). Per mezzo di questa modalità il passaggio dei dati di pagamento avviene esclusivamente in ambito
        bancario e www.teatrocolosseo.it non ha accesso ai numeri di carta di credito dei clienti.
    </p>
    <h5 class="my-5 font-bold text-xl">4. Prezzo dei biglietti</h5>
    <p>
        <b>4.1</b> Il Prezzo dei Titoli di Ingresso è quello indicato sul Sito in relazione a ciascun settore nella
        pagina di ciascun Evento. Il Prezzo dei Titoli di Ingresso non include le Commissioni di Servizio, che sono,
        tuttavia, specificamente indicate nel corso del procedimento di acquisto e, segnatamente, nel riepilogo
        dell’ordine che l’utente visualizza prima di procede alla conclusione del Contratto (“Riepilogo dell’Ordine”),
        unitamente all’importo totale che l’utente è tenuto a pagare in relazione a uno specifico ordine e che è
        costituito dal Prezzo dei Titoli di Ingresso comprensivo di diritto di prevendita più le Commissioni di Servizio
        (“Importo Totale”).<br />
        <b>4.2</b> Il Prezzo, la Prevendita e le Commissioni di Servizio sono espressi in Euro e devono considerarsi
        comprensivi di IVA. <br />
    </p>
    <h5 class="my-5 font-bold text-xl">5. Registrazione al Sito</h5>
    <p>
        <b>5.1</b> La registrazione al Sito è gratuita. Per registrarsi al Sito e creare il relativo account l’utente
        deve compilare l’apposito modulo, inserendo i propri dati personali nello stesso richiesti, oltre a un indirizzo
        e-mail e ad una password. È assolutamente e severamente vietato all’utente l’inserimento, ai fini della
        registrazione al Sito, di dati personali di terze persone, di dati falsi, inventati, di fantasia e/o, in
        qualsiasi modo, non corrispondenti al vero.<br />
        <b>5.2</b> Ciascun utente può usufruire di una sola registrazione al Sito. È pertanto assolutamente e
        severamente vietato all’utente creare sul Sito più account riferibili alla stessa persona, fisica e/o giuridica,
        e/o a società e/o enti di qualsiasi tipo, anche mediante l’utilizzo di dati corrispondenti al vero.
    </p>
    <h5 class="my-5 font-bold text-xl">6. Modalità di ricezione dei biglietti</h5>
    <p>I biglietti acquistati on-line verranno inviati in modalità Stampa&#64;casa all’indirizzo e-mail fornito in fase
        di registrazione. Il biglietto contiene al suo interno tutte le informazioni necessarie all'identificazione
        della validità del titolo di accesso (data, sala, titolo, orario), compreso un codice QR che consentirà al
        personale del teatro di scansionare il biglietto e consentire l'accesso dell'utente in sala. L’utente può
        presentarsi in teatro direttamente con il biglietto visualizzato sullo schermo dello smartphone o del tablet. Il
        biglietto costituisce di per sè titolo di accesso allo spettacolo ed è conforme a tutti i regolamenti e alle
        normative SIAE. Il biglietto non può essere duplicato nè riutilizzato, perchè la prima ed unica convalida
        impedisce qualsiasi utilizzo successivo.<br /> Il titolo di accesso andrà conservato fino al termine dell'evento
    </p>

    <h5 class="my-5 font-bold text-xl">7. Titoli di Ingresso ed Eventi</h5>
    <p>
        <b>7.1</b> Tutti i Portatori di Titoli di Ingresso devono essere muniti di un valido Titolo di Ingresso per
        accedere al Luogo dell’Evento.<br />
        <b>7.2</b> Il Titolo di Ingresso costituisce titolo di accesso esclusivamente per l’Evento per il quale è stato
        emesso, nel giorno e nell’ora ivi indicati. Il Teatro Colosseo ha la facoltà di rifiutare l’accesso al Luogo
        dell’Evento per irregolarità del Titolo di Ingresso e di effettuare controlli sulla persona per motivi di
        sicurezza. Nel caso in cui risulti che il Titolo di Ingresso sia stato rubato, duplicato o ottenuto in contrasto
        con le presenti CGC e/o con la legge, il Portatore del Titolo di Ingresso potrà non essere autorizzato ad
        accedere al Luogo dell’Evento.<br />
        <b>7.3</b> Nel caso in cui il Titolo di Ingresso sia stato perduto (cioè qualora la mail contenente il Titoli di
        ingresso fosse stata irrimediabilmente cestinata), il cliente potrà recuperarlo accedendo alla sezione “I miei
        biglietti” nella propria area personale sullo shop online www.teatrocolosseo.it<br />
        <b>7.4</b> Se il cliente non riceve i Titoli di ingresso, la mail o è stata cestinata erroneamente, o risulterà
        nella posta indesiderata. Non è possibile ricevere la conferma di acquisto da parte di Nexi e non i biglietti,
        visto che l’invio è contestuale.<br />
        <b>7.5</b>. Durante l’Evento il pubblico può essere oggetto di riprese e/o foto.<br />
        <b>7.6</b> Con il pagamento il cliente conclude l’acquisto del titolo d’accesso e quindi accetta e conferma – de
        facto - il contenuto relativo alla manifestazione fruibile.
    </p>
    <h5 class="my-5 font-bold text-xl">8. Evento rinviato o annullato</h5>
    <p>
        <b>8.1</b> Nel caso di rinvio o annullamento dell’Evento, il Teatro Colosseo comunicherà al Cliente le
        iniziative adottate.<br />
        <b>8.2</b> In nessun caso il Cliente potrà richiedere al Teatro Colosseo il rimborso dellecommissioni di
        servizio.<br />
        <b>8.3</b> Eventuali rinunce non danno diritto ad alcun rimborso, come pure i biglietti non ritirati e non
        utilizzati. Con il pagamento il cliente conclude l’acquisto del titolo d’accesso accetta e conferma – de facto -
        il contenuto relativo alla manifestazione fruibile. Conseguentemente all’avvenuto pagamento il titolo non può
        più essere restituito, cambiato con altro titolo d’accesso di ogni genere in ottemperanza a quanto disposto dal
        Decreto Legislativo 22 maggio 1999 n° 185 art.7 comma 1 lett. b); Decreto Legislativo 06 settembre 2005 n° 206
        art. 55 comma 1 lett. b) e successive modificazioni (esclusione del diritto di recesso in quanto all’atto della
        conclusione della transazione per nome e conto dell’Organizzatore si impegna a fornire la prestazione di
        servizio ad una data determinata).
    </p>
    <h5 class="my-5 font-bold text-xl">9. Divieti</h5>
    <p>
        <b>9.1</b> I Titoli di Ingresso non possono essere rivenduti a titolo oneroso nell’ambito dello svolgimento
        professionale di attività commerciale ancorché non organizzata sotto forma di impresa.
    </p>
    <h5 class="my-5 font-bold text-xl">10. Assistenza</h5>
    <p>
        <b>10.1</b> È possibile contattare il teatro ai recapiti: tel. 011-6698034 - mail <a href="mailto:cassa@teatrocolosseo.it">cassa&#64;teatrocolosseo.it</a>
    </p>
    <h5 class="my-5 font-bold text-xl">11. Limiti di responsabilità e diritti di www.teatrocolosseo.it</h5>
    <p>www.teatrocolosseo.it si riserva il diritto di ritirare, modificare, sospendere o interrompere qualsiasi funzione
        o servizio, qualora lo ritenga opportuno, per ragioni tecnicoorganizzative che possano in qualche modo
        compromettere la buona riuscita del proprio servizio.</p>
    <h5 class="my-5 font-bold text-xl">12. Protezione dei dati</h5>
    <p>
        <b>12.1</b> www.teatrocolosseo.it necessita - per lo svolgimento senza intoppi della vendita di biglietti - di
        informazioni di base quali il nome, l'indirizzo, numero di telefono e indirizzo Email dell'acquirente del
        biglietto. www.teatrocolosseo.it si attiene al diritto italiano sulla protezione dei dati nell'ambito
        dell'elaborazione dei dati del cliente.<br />
        <b>12.2</b> www.teatrocolosseo.it elabora, utilizza e salva i dati del cliente, se e nella misura in cui ciò si
        riveli necessario o utile per l'espletamento delle prestazioni. www.teatrocolosseo.it salva - oltre ai dati del
        cliente - la data dell'ordinazione e dell'invio della fornitura ai fini del controllo interno degli
        incarichi<br />
        <b>12.3</b> È possibile visualizzare la normativa completa sulla privacy all'indirizzo <a href="https://www.teatrocolosseo.it/privacy" target="_blank">https://www.teatrocolosseo.it/privacy</a>
    </p>
    <h5 class="my-5 font-bold text-xl">13. Cookies</h5>
    <p>
        <b>13.1</b> I cookies sono file di testo che il sito invia al computer dell'utente che vi si connette. I cookies
        non danneggiano i computer ai quali sono inviati e non sono in grado di registrare o modificare in alcun modo le
        informazioni personali ed i dati presenti nel sistema.
        <b>13.2</b> Mediante i cookies vengono salvate solo ed esclusivamente le informazioni atte a stabilire lo stato
        della sessione dell'utente.
    </p>
</section>